import styled from 'styled-components'

export const NursingIndicatorTable = styled.div`
  .left-col {
    padding: 9px 15px;
  }

  .right-col {
    min-width: 175px;
    padding: 9px 6px;
    vertical-align: bottom;
  }

  .label {
    margin-right: 8px;
  }

  .description-value {
    min-width: 122px;
    margin: 5px 13px 5px 0;
  }

  .description-meaning {
  }

  .table-footer {
    max-width: 750px;
    margin-top: 21px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .icon-arrow {
    display: inline-block;
    width: 16px;
    height: 8px;
    margin-right: 10px;
    color: #838383;
    vertical-align: top;
  }

  .option-label {
    display: inline-block;
    width: calc(100% - 26px);
  }

  .title {
    font-weight: bold;
  }
`
